/*
 * @Author: 范向玲
 * @Date: 2022-11-10 11:11:20
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-06-14 10:21:53
 * @Description: 走势库数据管理表格配置
 * @FilePath: \web\src\components\ProjectPerformance\DataManager\tableConfig.js
 */
const tableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '矿种',
    dataIndex: 'commodity',
    slots: {
      customRender: 'commodity',
    },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '指标名称',
    dataIndex: 'name',
    slots: {
      customRender: 'name',
    },
    ellipsis: true,
    align: 'center',
    width: 200,
  },
  {
    title: '指标类型',
    dataIndex: 'type',
    ellipsis: true,
    align: 'center',
  },
  // {
  //   title: '价格',
  //   dataIndex: 'price',
  //   ellipsis: true,
  //   align: 'center',
  // },
  {
    title: '频率',
    dataIndex: 'frequency',
    ellipsis: true,
    align: 'center',
    // width: 100,
  },
  {
    title: '单位',
    dataIndex: 'unit',
    ellipsis: true,
    align: 'center',
    // width: 200,
  },
  {
    title: '数据来源',
    dataIndex: 'source',
    slots: {
      customRender: 'source',
    },
    ellipsis: true,
    align: 'center',
    // width: 100,
  },
  {
    title: '坐标轴',
    dataIndex: 'axis',
    slots: {
      customRender: 'axis',
    },
    ellipsis: true,
    align: 'center',
    // width: 100,
  },
  {
    title: '开始时间',
    dataIndex: 'startDate',
    ellipsis: true,
    align: 'center',
    // width: 200,
  },
  {
    title: '结束时间',
    dataIndex: 'endDate',
    ellipsis: true,
    align: 'center',
    // width: 200,
  },
  // {
  //   title: '时间区间',
  //   dataIndex: 'timeRange',
  //   ellipsis: true,
  //   align: 'center',
  //   width: 200,
  // },
  {
    title: '更新时间',
    dataIndex: 'updateTime',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    dataIndex: 'action',
    slots: { customRender: 'action' },
    align: 'center',
    width: 180,
  },
];

const detailTableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '价格',
    dataIndex: 'price',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'price' },
  },
  {
    title: '时间',
    dataIndex: 'date',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'date' },
  },
  {
    title: '备注',
    dataIndex: 'remark',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'remark' },
    // width: 200,
  },
  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action' },
    align: 'center',
    // width: 180,
  },
];
/**
 * 走势库数管 矿种排序
 */
const sortTableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '矿种',
    dataIndex: 'commodity',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action' },
    align: 'center',
    // width: 180,
  },
];
const downloadInfoConf = [
  [
    {
      name: '日期排序',
      type: 'radio',
      children: [
        { key: 'desc', name: '日期降序' },
        { key: 'asc', name: '日期升序' },
      ],
      selectValue: '',
      valueType: 'str',
    },
  ],
  // [
  //   {
  //     name: '包含指标',
  //     type: 'checkbox',
  //     children: [
  //       { key: '单位', name: '单位', },
  //       { key: '数据来源', name: '数据来源', },
  //       { key: '频率', name: '频率', },
  //       { key: '时间区间', name: '时间区间', },
  //       { key: '结束时间', name: '结束时间', },
  //       { key: '更新时间', name: '更新时间', },
  //       { key: '指标描述', name: '指标描述', },
  //     ],
  //     selectValue: [],
  //     valueType: 'arr',
  //   },
  // ],
  // [
  //   {
  //     name: 'excel作图',
  //     type: 'checkbox',
  //     children: [
  //       { key: '显示图形', name: '显示图形', },
  //     ],
  //     selectValue: [],
  //     valueType: 'arr',
  //   },
  //   {
  //     name: '图形样式',
  //     type: 'radio',
  //     children: [
  //       { key: '折线', name: '折线', },
  //       { key: '柱状', name: '柱状', },
  //     ],
  //     selectValue: '',
  //     valueType: 'str',
  //   },
  // ],
];

export { tableConfig, downloadInfoConf, detailTableConfig, sortTableConfig };
